import { ShapeProps } from './types';

export const Blink = ({ className }: ShapeProps) => (
    <svg
        className={className}
        width="23"
        height="24"
        viewBox="0 0 23 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21.2941 11.8C15.8299 11.8 11.3941 7.36948 11.3941 1.89995C11.3941 7.3642 6.96367 11.8 1.49414 11.8C6.95839 11.8 11.3941 16.2304 11.3941 21.7C11.3941 16.2357 15.8246 11.8 21.2941 11.8Z"
            stroke="#313131"
            strokeWidth="2.7"
            strokeLinejoin="round"
        />
    </svg>
);
